const FOOTER_LINKS = ["Privacy Policy", "Security", "Terms of Service", "Contact"] as const;

export function AppFooter() {
  return (
    <footer className="bg-footer-bg flex flex-wrap items-center justify-between gap-3 px-6 py-3">
      <div className="flex items-center gap-3">
        <div className="flex flex-col leading-none">
          <span className="text-trux-navy-soft text-badge-sm tracking-brand-2 font-extrabold">
            TRU<span className="text-trux-teal">X</span>✓
          </span>
          <span className="text-footer-label text-3xs mt-0.5 font-semibold tracking-widest uppercase">
            Retail Partner
          </span>
        </div>
        <span className="bg-footer-divider h-divider w-px" />
        <div className="text-footer-link text-xxs flex items-center gap-3">
          {FOOTER_LINKS.map((label) => (
            <span key={label}>{label}</span>
          ))}
        </div>
      </div>
      <span className="text-footer-copy text-xxs">
        © {new Date().getFullYear()} TruX Retail AI. All rights reserved.
      </span>
    </footer>
  );
}
